import { mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
let timer = null;
export default {
    name: 'dppPhoto',
    inject: ['$eventBus'],
    components: {
        mvtMapStatic,
    },
    data() {
        return {
            mainScrollerIndex: 0,
            categoryScrollUpHidden: true,
            categoryScrollDownHidden: true,
            isMounted: false,
            categoryIndex: 0,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getCategories', 'getPhotos']),
        photoCount() {
            return this.getPhotos.length + this.mapImages.length + (this.dpp.isActive ? 1 : 0);
        },
        leftScrollHidden() {
            return this.mainScrollerIndex <= 0;
        },
        rightScrollHidden() {
            return this.mainScrollerIndex >= this.photoCount - 1;
        },
        isHeroStreetView() {
            return this.getPhotos.length === 0 && !!this.glb.welcomeImage;
        },
        mapImages() {
            let images = [];
            if (this.getPhotos.length < 4) {
                if (!this.getSplit('movoto-streetview-CW-4475')) {
                    images.push({
                        type: 'streetview',
                        fallback: 'roadmap',
                        placeholder: this.getPhotos.length === 0 ? this.glb.welcomeImage : '',
                        eager: this.isHeroStreetView,
                    });
                }

                if (this.getSplit('movoto-streetview-CW-4475', 'on2')) {
                    images.push({
                        type: 'terrain',
                        placeholder: this.getPhotos.length === 0 ? this.glb.welcomeImage : '',
                    });
                    images.push({
                        type: 'satellite',
                    });
                } else if (this.getSplit('movoto-streetview-CW-4475', 'on1')) {
                    images.push({
                        type: 'satellite',
                        placeholder: this.getPhotos.length === 0 ? this.glb.welcomeImage : '',
                    });
                    images.push({
                        type: 'terrain',
                    });
                } else {
                    images.push({
                        type: 'satellite',
                    });
                    images.push({
                        type: 'terrain',
                    });
                }
            }
            return images;
        },
        markers() {
            return [{ lat: this.dpp.geo.lat, lng: this.dpp.geo.lng, type: this.dpp.propertyType }];
        },
    },
    methods: {
        ...mapMutations('dpp', ['updateMapUrls']),
        ...mapGetters('glb', ['getComplianceMethod']),
        showWatermark() {
            const compliance = this.getComplianceMethod()();
            return compliance[0]?.rule.indexOf('showMlsWatermarkOnViewArea') >= 0;
        },
                getUrl(urls) {
            if (urls && urls.src) {
                this.updateMapUrls(urls);
            }
        },
        // Check if an element is currently visible in the viewport
        isElementInViewport(element, container) {
            if (!element || !container) return false;
            const elementRect = element.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            // Check if element is within the container's visible area
            return elementRect.top >= containerRect.top && elementRect.bottom <= containerRect.bottom && elementRect.left >= containerRect.left && elementRect.right <= containerRect.right;
        },
        // these scroll handlers are not meant to be called directly, create a debounced version in mounted and use that
        mainPhotoScrolled(e) {
            const width = e.target.clientWidth;
            const scrollLeft = e.target.scrollLeft;
            // corresponds to the active index at the end of a scroll
            const diff = Math.round(scrollLeft / width);
            this.mainScrollerIndex = diff;
            this.$eventBus.$emit('ga4', { en: 'photo_scrolled', ec: this.$options.name, el: `photo ${diff + 1}` });
        },
        categoriesScrolled(e) {
            const photoScrollerRect = this.$refs?.categoryPhotoScroller?.getBoundingClientRect();
            const lastChildRect = this.$refs?.categoryPhotoScroller?.lastElementChild?.getBoundingClientRect();
            this.categoryScrollDownHidden = photoScrollerRect?.bottom && lastChildRect?.bottom && photoScrollerRect?.bottom === lastChildRect?.bottom;
            this.categoryScrollUpHidden = e.target.scrollTop === 0;
        },
        keyScroll(e) {
            const code = e?.code;
            if (['ArrowLeft', 'ArrowRight'].includes(code)) {
                if (code === 'ArrowLeft') {
                    this.scrollLeft();
                } else if (code === 'ArrowRight') {
                    this.scrollRight();
                }
            }
        },
        scrollCategoriesDown() {
            const top = this.$refs.categoryPhotoScroller?.firstElementChild?.clientHeight + 8;
            this.$refs.categoryPhotoScroller.scrollBy({ top, behavior: 'smooth' });
        },
        scrollCategoriesUp() {
            const top = -1 * this.$refs.categoryPhotoScroller?.firstElementChild?.clientHeight - 8;
            this.$refs.categoryPhotoScroller.scrollBy({ top, behavior: 'smooth' });
        },
        scrollLeft() {
            this.scrollToPhotoIndex(Math.max(this.mainScrollerIndex - 1, 0));
        },
        scrollRight() {
            this.scrollToPhotoIndex(Math.min(this.mainScrollerIndex + 1, this.photoCount - 1));
        },
        scrollToPhotoIndex(i, behavior = 'smooth') {
            this.$refs.mainPhotoScroller?.children?.[i]?.scrollIntoView({ behavior, block: 'nearest' });
            this.mainScrollerIndex = i;
        },
        setCategory(i) {
            const indexOfFirstCategoryPhoto = this?.getPhotos?.indexOf(this.getPhotos.find((p) => p.cateIndex === i)) || 0;
            this.scrollToPhotoIndex(indexOfFirstCategoryPhoto, 'instant');
        },
        getAutoplayParam(url) {
            if (url.includes('matterport.com')) {
                return url.includes('?') ? '&play=1' : '?play=1';
            }
            if (['vimeo.com', 'youtube.com'].find((site) => url.includes(site))) {
                return url.includes('?') ? '&autoplay=1' : '?autoplay=1';
            }
            return '';
        },
        pop3d(type = '3D') {
            const url = type === '3D' ? this.dpp.threeDTourLink : this.dpp.videoTourLink;
            const autoplayURL = `${url}${this.getAutoplayParam(url)}`;
            this.$eventBus.$emit('property-pop-3d', autoplayURL);
        },
        forceLoadMaps() {
            const maps = this.$refs.map;
            if (maps) {
                const list = Array.isArray(maps) ? maps : [maps];
                list.forEach((m) => m.forceLoad());
            }
        },
        openPhotoView(forceSingle) {
            if (this.dpp.hidePhotosByCompliance) {
                this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin' }, trigger: this.$options.name });
                return;
            }
            this.forceLoadMaps();
            if (this.getPhotos && this.getPhotos.length > this.mainScrollerIndex) {
                let item = this.getPhotos[this.mainScrollerIndex];
                this.$eventBus.$emit('property-pop-photo', { cateIndex: item.cateIndex || 0, photoIndex: item.index || 0, single: forceSingle || !this.glb.isPhone });
            } else {
                this.$eventBus.$emit('property-pop-photo', { cateIndex: 0, photoIndex: this.mainScrollerIndex || 0, single: forceSingle || !this.glb.isPhone });
            }
        },
        popMapView(id) {
            if (id === 0) {
                this.openPhotoView();
            } else {
                this.$eventBus.$emit('property-pop-map', { popMapTypeId: id || 0, popStreetView: false });
            }
        },
        scrollIntoCategoryView() {
            let container = this.$refs.categoryPhotoScroller;
            const activeElement = container?.querySelector('li.active');
            //always scroll to the center of the container
            if (window.innerWidth > this.glb.viewport.smScreen[1]) {
                container?.scrollTo({
                    top: activeElement?.offsetTop - container?.clientHeight / 2 + activeElement?.clientHeight / 2,
                    behavior: 'smooth',
                });
            } else {
                container?.scrollTo({
                    left: activeElement?.offsetLeft - container?.clientWidth / 2 + activeElement?.clientWidth / 2,
                    behavior: 'smooth',
                });
            }
        },
        openHotlead(buttonText) {
            this.$eventBus.$emit('property-pop-schedule', {
                date: new Date(),
                hotleadType: 'SwipePastPhotosRequestTour',
                hotleadTitle: this.testRequestTour ? this.molang('dpp.hotButton.requestTour') : this.molang('dpp.hotButton.requestaTour'),
                changeDate: true,
                trigger: this.testRequestTour ? 'propertyTour' : this.$options.name,
                buttonText: this.testRequestTour ? this.molang('dpp.hotleadForm.submit') : buttonText,
                hideProfile: this.testRequestTour,
                showAddressAndImage: this.testRequestTour,
                hotleadSub: this.testRequestTour ? this.molang('dpp.propertySchedule.seeThisHome') : '',
            });
        },
    },
    watch: {
        mainScrollerIndex(newVal) {
            let photo = this.getPhotos[newVal];
            if (photo) {
                this.categoryIndex = photo?.cateIndex || 0;
            }
        },
        categoryIndex() {
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(this.scrollIntoCategoryView);
        },
    },
    mounted() {
        this.isMounted = true;
        this.mainPhotoScrolledDebounced = debounce(this.mainPhotoScrolled, 100);
        this.categoriesScrolledDebounced = debounce(this.categoriesScrolled, 100);
        this.categoryScrollDownHidden = this.getCategories.length <= 3;
    },
};
